export const LADE_AUSWAHLWERTE_ARTIKEL = "ladeAuswahlwerteArtikel";
export const LADE_ARTIKEL = "ladeArtikel";
